import React, { Component } from "react";
import { connect } from 'react-redux';

import _ from 'i18n';
import { setEventsFilters } from 'actions';
import { fetchGroups, fetchEvents } from 'thunks';
import TTPSelect from "common/TTPSelect";
import GroupsFilters from "./GroupsFilters";
import MailingListFilters from "./MailingListFilters";
import {setCurrentEmailCampaignData} from "../../../../actions/actions/currentCampaign";
import {
  isEventPast,
  sortEventByStartDateTime,
  transformDateFormat,
  ucFirst
} from "../../../../services/common";

@connect((store) => {
  return {
    events: store.filters.events.items,
    language: store.params.lng,
    campaignLanguage: store.currentCampaign.email.language,
    eventFilters: store.currentCampaign.email.eventFilters,
    commitmentScoreRange: store.currentCampaign.email.commitmentScoreRange,
    currentUser: store.auth.user
  }
})
export default class ContactFilters extends Component {

  constructor(props) {
    super(props);
    const {commitmentScoreRange} = this.props;
    const commitmentScore = (typeof commitmentScoreRange === 'string') ? commitmentScoreRange.split(',') : commitmentScoreRange;
    this.state = {
      rangeValue: {min: commitmentScore[0] ?? commitmentScore.min , max: commitmentScore[1] ?? commitmentScore.max},
      eventsType: 'future',
      allCommunities: false,
    };
  }

  handleChangeCommitmentScoreRange = () => {
    const {dispatch} = this.props;
    dispatch(setCurrentEmailCampaignData({commitmentScoreRange: this.state.rangeValue}));
  };

  async componentWillMount() {
    const {recipientType, dispatch, eventFilters} = this.props;
    dispatch(fetchGroups(recipientType));
    await dispatch(fetchEvents());
    let events  = this.props.events;
    let filters = (eventFilters || []).filter(
      filter => filter.property === 'guest.event' && filter.operator === 'nin'
    );
    let allEventIds = filters.flatMap(filter => filter.value);
    let foundAll = allEventIds.every(eventId => events.some(e => e.id.toString() === eventId));

    let allCommunities = false;
    if (!foundAll && allEventIds.length > 0) {
      allCommunities = true;
      await dispatch(fetchEvents(null, null, '', true));
      events = this.props.events; // re-read after fetch
    }

    let eventsType = 'future';
    filters.forEach(filter => {
      filter.value.forEach(eventId => {
        const event = events.find(e => e.id.toString() === eventId);
        if (event && isEventPast(event)) {
          eventsType = 'past';
        }
      });
    });

    this.setState({ allCommunities, eventsType });
  }

  renderListOption(option) {
    return <div className="select-option">
      <span className="select-option__label">{option.label}</span>
      <span className="select-option__content">{option.subscribers} {_('subscribed contacts')}</span>
    </div>;
  }


  handleEventChange = (events) => {
    this.props.dispatch(setEventsFilters({ property: 'guest.event', operator: 'nin', value: events }))
  }

  handleAllCommunitiesChange = async () => {
    const {dispatch, currentUser} = this.props;
    await this.setState({allCommunities: !this.state.allCommunities});

    if (this.state.allCommunities) {
      await dispatch(fetchEvents(null, null, '', true));
    } else {
      this.props.dispatch(setEventsFilters({ property: 'guest.event', operator: 'nin', value: [] }));
      await dispatch(fetchEvents());
    }
  }

  render() {
    const { events, eventFilters, campaignLanguage, currentUser } = this.props;
    const { eventsType, allCommunities } = this.state;

    let filterMapping = (eventFilters || []).reduce((filters, filter) => {
      let key = `${filter.property}-${filter.operator}`;
      filters[key] = filter.value;
      return filters;
    }, {});
    let excludedEventGuests = filterMapping['guest.event-nin'] || "";
    let allUserClients = currentUser?.clients || [];

    let lng = ucFirst(campaignLanguage);
    let sortedEvents = sortEventByStartDateTime(events, 'DESC', eventsType)
    let eventOptions = sortedEvents?.map(event => {
    let organizationName = allCommunities && allUserClients?.some(client => client.id === event['client'])
      ? allUserClients?.find(client => client.id === event['client'])?.abbreviation
      : '';
      const getEventName = () => {
        if (lng !== 'All' && event[`name${lng}`]) {
          return event[`name${lng}`];
        }
        // Fallback order: Fr -> Nl -> En
        return event['nameFr'] || event['nameNl'] || event['nameEn'] || 'Unnamed Event';
      };

      const eventName = getEventName();
      const eventStartDate = transformDateFormat(event['startDateTime']);

      return {
        label: `${eventStartDate} || ${eventName} ${organizationName ? `(${organizationName})` : ''}`,
        id: event.id.toString()
      };
    });

    return (
      <div>
        <div className="row" style={{maxWidth: 'unset'}}>
          <MailingListFilters />
          <div className="columns small-6 columns-padding">
            <div className="sidebar__form-control">
              <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '1rem 0 0.8rem'}}>
              <h1 className="param__title" style={{margin: '0', padding: '0'}}>
                {_('exclude event registrants')}
              </h1>
              <div style={{display: 'flex', alignItems: 'center'}}>
                <span style={{display: 'flex', gap: '5px'}}>
                  <input
                    type="checkbox"
                    style={{display: 'flex', marginBottom: '0'}}
                    id={'1'}
                    checked={this.state.allCommunities}
                    onChange={() => this.handleAllCommunitiesChange()}
                  />
                  <span>{_('allMyCommunities')}</span>
                </span>
                <span style={{marginLeft: '32px', display: 'flex'}}>
                  <input type="radio" name='future' style={{margin: 'unset'}} defaultChecked={true} checked={this.state.eventsType === 'future'} onChange={() => this.setState({...this.state, eventsType: 'future'})}/>
                  <span className="ttp-radio"></span>
                  <span style={{marginLeft: '5px'}}>{_('future')}</span>
                </span>
                <span style={{margin: '0 10px 0 10px', display: 'flex'}}>
                  <input type="radio" name='replay' style={{margin: 'unset'}} defaultChecked={false} checked={this.state.eventsType === 'past'} onChange={() => this.setState({...this.state, eventsType: 'past'})}/>
                  <span className="ttp-radio"></span>
                  <span style={{marginLeft: '5px'}}>{_('past')}</span>
                </span>
              </div>
              </div>
              <TTPSelect
                values={excludedEventGuests}
                placeholder={_('Select event')}
                options={eventOptions}
                onChange={this.handleEventChange} />
            </div>
          </div>
        </div>
        <GroupsFilters />
        {/*<div className="row slider-container medium-4">*/}
        {/*  <h1 className="param__title">{_('commitment score')}</h1>*/}
        {/*  <RangeSlider*/}
        {/*    maxValue={100}*/}
        {/*    minValue={0}*/}
        {/*    value={this.state.rangeValue}*/}
        {/*    onChange={value => this.setState({ rangeValue: value })}*/}
        {/*    onChangeComplete={this.handleChangeCommitmentScoreRange} />*/}
        {/*</div>*/}
      </div>
    );
  }
}
